<template>
  <div>
    <v-dialog v-model="approveModal" max-width="400">
      <v-card class="pa-4" outlined v-if="request">
        <h3 class="text-center"><strong>Aprovar solicitação</strong></h3>
        <p class="text-center">
          Tem certeza de que deseja aprovar a solicitação de uso do padrão
          {{ request.calibrationV2Pattern.name }} feita pela instituição
          {{ request.institutionRequester.name }}
        </p>

        <div class="d-flex justify-center align-center my-2">
          <v-btn
            class="primary-button ma-1"
            depressed
            @click="approveModal = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            class="secondary-button ma-1"
            depressed
            @click="approveRequest"
          >
            Aprovar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog v-model="disapproveModal" max-width="400">
      <v-card class="pa-4" outlined v-if="request">
        <h3 class="text-center"><strong>Reprovar solicitação</strong></h3>
        <p class="text-center">
          Tem certeza de que deseja reprovar a solicitação de uso do padrão
          {{ request.calibrationV2Pattern.name }} feita pela instituição
          {{ request.institutionRequester.name }}
        </p>

        <div class="d-flex justify-center align-center my-2">
          <v-btn
            class="primary-button ma-1"
            depressed
            @click="disapproveModal = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            class="secondary-button ma-1"
            depressed
            color="error"
            @click="disapproveRequest"
          >
            Reprovar
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <div class="d-flex justify-end">
      <v-btn
        class="primary-button ml-2"
        depressed
        @click="showFilter = !showFilter"
      >
        {{ showFilter ? 'Fechar filtros' : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-if="showFilter">
        <div class="my-2 d-flex justify-end align-center">
          <v-text-field
            v-model="filter.search"
            placeholder="Pesquise pelo nome do padrão, nome do equipamento ou identificação do equipamento"
            class="primary-input mt-4"
            outlined
            style="max-width: 700px"
            hide-details
          ></v-text-field>
          <v-btn
            class="ma-0 primary-button ml-2"
            depressed
            @click=";(page = 1), list()"
          >
            Filtrar
          </v-btn>
        </div>
      </div>
    </v-expand-transition>

    <v-data-table
      :headers="headers"
      :items="patterns"
      class="main-table"
      hide-default-footer
      :items-per-page="pageSize"
      :loading="loading"
      :header-props="headerProps"
    >
      <template #[`item.status`]="{ item }">
        <v-chip class="pa-2" :color="getColor(item.status)">
          <span style="font-size: 12px">{{ statusList[item.status] }}</span>
        </v-chip>
      </template>

      <template #[`item.name`]="{ item }">
        {{ item.name }}
      </template>

      <template #[`item.calibrationV2Pattern.expirationDate`]="{ item }">
          <div class="d-flex flex-column align-center">
            <span>{{ formatDate(item.calibrationV2Pattern.expirationDate) }}</span>
            <v-chip
              v-if="isExpired(item.calibrationV2Pattern.expirationDate)"
              x-small
              color="error"
              dark
              class="mt-1"
            >
              Vencido
            </v-chip>
          </div>
      </template>

      <template #[`item.actions`]="{ item }">
        <div class="d-flex align-center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status == 2"
                color="secondary"
                class="ma-1"
                dark
                tile
                fab
                x-small
                depressed
                style="border-radius: 5px"
                v-bind="attrs"
                v-on="on"
                @click="setRequestIdAndOpenApproveModal(item)"
              >
                <v-icon>mdi-check-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Aprovar') }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="item.status == 2"
                color="error"
                class="ma-1"
                dark
                tile
                fab
                x-small
                depressed
                style="border-radius: 5px"
                v-bind="attrs"
                v-on="on"
                @click="setRequestIdAndOpenDisapproveModal(item)"
              >
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Reprovar') }}</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>

    <div class="pagination">
      <div class="item-pagination block-one">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="btn"
              depressed
              color="#C0C0C0"
              small
            >
              qtd: {{ pageSize }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(size, i) in sizes"
              :key="i"
              @click="pageSize = size"
            >
              <v-list-item-title>{{ size }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="registros" v-if="totalItensOnPage">
          <span> {{ pageStart }} - {{ pageEnd }} de {{ totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="page"
          :length="totalPages"
          :total-visible="9"
        ></v-pagination>
      </div>
    </div>
    <schedulingForm
      v-model="showSchedulingDialog"
      :event-data="eventForm"
      :institution="institution"
      :event-colors="eventColors"
    />
  </div>
</template>

<script>
import moment from 'moment'
import schedulingForm from './../../../EquipmentCentral/components/EventFormDialog.vue'
import ApiService from '../../../../../services/ApiService'

export default {
  name: 'institutionPatternTable',
  components: {
    schedulingForm,
  },

  data() {
    return {
      request: null,
      showFilter: false,
      patterns: [],
      pageSize: 10,
      sizes: [10, 25, 50],
      totalItems: 4,
      totalItensOnPage: 4,
      totalPages: 1,
      page: 1,
      loading: false,
      filter: {
        page: 1,
        pageSize: 10,
      },
      apiService: new ApiService(),
      headerProps: {
        sortByText: 'Ordenar por',
      },
      statusList: [
        'Aprovado',
        'Reprovado',
        'Aguardando aprovação',
        'Não encontrado',
      ],
      headers: [
        { text: '', align: 'center', value: '', sortable: false },
        {
          text: 'Status',
          align: 'center',
          value: 'status',
          sortable: false,
        },
        {
          text: 'Institutição solicitante',
          align: 'center',
          value: 'institutionRequester.name',
          sortable: false,
        },
        {
          text: 'Padrão',
          align: 'center',
          value: 'calibrationV2Pattern.name',
          sortable: false,
        },
        {
          text: 'Equipamento',
          align: 'center',
          value: 'calibrationV2Pattern.equipment.identification',
          sortable: false,
        },
        {
          text: 'Validade',
          align: 'center',
          value: 'calibrationV2Pattern.expirationDate',
          sortable: false,
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      disapproveModal: false,
      approveModal: false,
      disapproveModalKey: false,
      approveModalKey: false,
      showSchedulingDialog: false,
      institution: null,
      eventColors: [
        { name: 'Azul', value: '#2196f3' },
        { name: 'Verde', value: '#4caf50' },
        { name: 'Roxo', value: '#9c27b0' },
        { name: 'Vermelho', value: '#f44336' },
        { name: 'Laranja', value: '#ff9800' },
        { name: 'Azul-esverdeado', value: '#009688' },
      ],
      eventForm: {
        calibrationPattern: [],
        destinationInstitution: null,
        destinationUnidade: null,
        patternRequestId: null,
        userId: null,
        startDateTime: '',
        endDateTime: '',
        alert: false,
        alertDateTime: '',
        color: '#2196f3',
        details: '',
        supplierId: null,
      },
      user: [],
    }
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.user = JSON.parse(localStorage.getItem('user'))
    this.filter.institutionId = this.institution.id
    this.list()
  },

  methods: {
      isExpired(date) {
        if (!date) return false;
        return moment(date).isBefore(moment(), 'day');
      },
    approveRequest() {
      const model = {
        requestId: this.request.id,
        status: 0,
      }

      this.apiService
        .post('calibration/v2/pattern/answer-borrow', model)
        .then((response) => {
          this.$toast.success('Solicitação aprovada com sucesso!')
          this.approveModal = false
          this.request = null
          this.list()
        })
    },

    disapproveRequest() {
      const model = {
        requestId: this.request.id,
        status: 1,
      }

      this.apiService
        .post('calibration/v2/pattern/answer-borrow', model)
        .then((response) => {
          this.$toast.success('Solicitação reprovada com sucesso!')
          this.disapproveModal = false
          this.request = null
          this.list()
        })
    },

    setRequestIdAndOpenApproveModal(item) {
      this.request = item
      this.approveModal = true
      this.approveModalKey = !this.approveModalKey
    },

    setRequestIdAndOpenDisapproveModal(item) {
      this.request = item
      this.disapproveModal = true
      this.disapproveModalKey = !this.disapproveModalKey
    },

    getColor(status) {
      switch (status) {
        case 0:
          return 'secondary'
        case 1:
          return 'error'
        case 2:
          return 'accent'
        default:
          return 'info'
      }
    },

    list() {
      this.loading = true
      this.apiService
        .get('calibration/v2/pattern/requests', this.filter)
        .then((response) => {
          this.loading = false
          this.patterns = response.content.data
          this.totalItems = response.content.pager.totalItems
          console.log(this.patterns)

          const start = (this.page - 1) * this.pageSize + 1
          const end = Math.min(this.page * this.pageSize, this.totalItems)
          this.pageStart = start
          this.pageEnd = end
          this.totalPages = Math.ceil(this.totalItems / this.pageSize)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openSchedulingDialog(item) {
      this.editingEvent = false
      this.eventForm = {
        calibrationPattern: [item.calibrationV2Pattern.id],
        destinationInstitution: item.institutionRequester.id,
        destinationUnidade: item.calibrationV2Pattern.equipment.unidadeId,
        userId: this.user.id,
        patternRequestId: item.id,
        startDateTime: '',
        endDateTime: '',
        alert: false,
        alertDateTime: '',
        color: '#2196f3',
        details: '',
        supplierId: null,
      }

      this.showSchedulingDialog = true
    },

    formatDate(date) {
      if (date) return moment(date).format('DD/MM/yyyy')
      else return 'Sem registro'
    },

    viewItem(item) {
      console.log('Visualizar item', item)
    },
  },

  watch: {
    page() {
      this.filter.page = this.page
      this.list()
    },

    pageSize() {
      this.filter.pageSize = this.pageSize
      this.list()
    },
  },
}
</script>

<style></style>
